import { useEffect, useState } from "react";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import { IMatchPartyEmail } from "..";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../../ApiTS/ServiceDatasTS";
import { Textarea } from "../../../../../Input/Textarea";
import { Input } from "../../../../../Input/Input";
import AlertModal from "../../../../../Modal/AlertModal";
import { pwAutoChangeMain } from "../../../../../../ApiTS/ApiPwAutoChangeTS";
import { toast } from "react-toastify";
import Loader from "../../../../../DefaultStyles/Loader";
import { useApi } from "../../../../../../hooks/useApi";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import { decryptPW, encryptPW } from "../../../../../../Api/ApiCommon";
import { randomPw } from "../../../../Manage/TempAccount/TempAccount/TempAccountModal/PwAutoChangeBtn";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../../../AdminApi/3.0_utils";
import {
  GetServiceSetData_V3,
  GetSubscriptionSetData_V3,
} from "../../../../../../ApiTS/ServiceDatasTS_V3";

interface MatchMakingEmailInfoModalProps extends DefaultModalCommonProps {
  data?: IMatchPartyEmail;
  refetch: () => void;
}

export default function MatchMakingEmailInfoModal({
  closeEvent,
  data,
  refetch,
}: MatchMakingEmailInfoModalProps) {
  const decryptedPw = data?.password
    ? decryptPW(
        data?.password,
        data?.servsubsid === 31000 || data?.servsubsid === 33000 ? 3 : 1
      )?.pw
    : "";

  console.log(decryptedPw);

  const [newPassword, setNewPassword] = useState(
    data?.password ? decryptedPw : ""
  );
  const [password, setPassword] = useState(data?.password ? decryptedPw : "");
  const [comment, setComment] = useState(data?.comment ?? "");
  const [askChangeAlert, setAskChangeAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [save, setSave] = useState(false);

  const subsData = GetSubscriptionSetData_V3(data?.servsubsid ?? 0);
  const svcData = GetServiceSetData_V3(subsData?.SVC_ID ?? 0);
  const serviceName = getString3ByKey(Number(svcData?.SVC_NM)) ?? "";

  const {
    response: commentReseponse,
    loading: commentLoading,
    error: commentError,
  } = useApi({
    method: "post",
    url:
      save && comment !== "" && comment !== data?.comment
        ? `matchParty/email/update`
        : undefined,
    data: {
      id: data?.id ?? 0,
      comment,
    },
  });

  const {
    response: pwReseponse,
    loading: pwLoading,
    error: pwError,
  } = useApi({
    method: "post",
    url:
      save && (newPassword !== decryptedPw || password !== decryptedPw)
        ? `matchParty/email/update/pw`
        : undefined,
    data: {
      id: data?.id ?? 0,
      password: encryptPW(
        {
          pw: newPassword !== decryptedPw ? newPassword : password,
          ...(data?.servsubsid === 3000 ? { adltPw: "1234" } : {}),
        },
        data?.servsubsid === 31000 || data?.servsubsid === 33000 ? 3 : 1
      ),
    },
  });

  const pwChange = async () => {
    setIsLoading(true);

    const newPw = randomPw(0, "good_");

    const response = await pwAutoChangeMain(
      data?.servsubsid ?? 0,
      data?.email ?? "",
      decryptedPw ?? "",
      newPw
    );

    if (response) {
      setIsLoading(false);

      if (response?.data && response?.data?.hasChanged) {
        setNewPassword(newPw);
        setSave(true);
      } else {
        toast.error(`${serviceName} 비밀번호를 바꾸는 데에 실패하였습니다.`);
      }
    }
  };

  useEffect(() => {
    if (commentReseponse?.status === 200 || pwReseponse?.status === 200) {
      toast.success("이메일 정보를 업데이트 했습니다.");
      closeEvent();
      refetch();
    }
  }, [commentReseponse, pwReseponse]);

  useEffect(() => {
    if (commentError || pwError) {
      setSave(false);
      toast.error(
        pwError?.data ??
          commentError?.data ??
          (pwError
            ? "비밀번호를 변경하는 데에 실패하였습니다."
            : commentError
            ? "이메일 정보를 수정하는 데에 실패하였습니다."
            : "업데이트에 실패하였습니다.")
      );
    }
  }, [commentError, pwError]);

  console.log(
    decryptedPw === newPassword,
    decryptedPw === password,
    data?.comment ? data?.comment! === comment : false
  );

  return (
    <>
      <DefaultModalLayout
        modalTitle="매치메이킹 계정 관리"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setAskChangeAlert(true)}
        confirmBtnText="수정하기"
        confirmDisabled={
          data?.password && data?.comment
            ? Boolean(
                decryptedPw === newPassword &&
                  decryptedPw === password &&
                  (data?.comment ? data?.comment! === comment : false)
              )
            : decryptedPw === newPassword &&
              decryptedPw === password &&
              comment === ""
        }
      >
        <ModalRow>
          <ModalLabel>Subscription</ModalLabel>

          <ModalFixedBox style={{ width: "calc(100% - 106px)" }}>
            {data?.servsubsid}_
            {getSubsNameBySubsId3(data?.servsubsid ? +data?.servsubsid : 0) ??
              ""}
          </ModalFixedBox>
        </ModalRow>

        <ModalRow>
          <ModalLabel>계정 이름</ModalLabel>

          <ModalFixedBox style={{ width: "calc(100% - 106px)" }}>
            {serviceName ?? ""}_{data?.id}
          </ModalFixedBox>
        </ModalRow>

        <ModalRow>
          <ModalLabel>이메일</ModalLabel>

          <ModalFixedBox style={{ width: "calc(100% - 106px)" }}>
            {data?.email}
          </ModalFixedBox>
        </ModalRow>

        <ModalRow>
          <ModalLabel>비밀번호</ModalLabel>

          <ModalRowContentContainer>
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            {data?.password && (
              <ConfirmBtn
                btnText="변경하기"
                btnColor="mint"
                isDisabled={newPassword === ""}
                btnClickEvent={() => pwChange()}
              />
            )}
          </ModalRowContentContainer>
        </ModalRow>

        <ModalLabel>코멘트</ModalLabel>

        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="100자 이내 내용 입력"
        />
      </DefaultModalLayout>

      {askChangeAlert && (
        <AlertModal
          title={`입력한 정보로 계정 정보가 변경됩니다.\n계속하시겠습니까?`}
          cancelEvent={() => setAskChangeAlert(false)}
          confirmEvent={() => {
            if (data?.password && newPassword !== decryptedPw) {
              // 기존에 있던 비밀번호를 수정한 경우
              pwChange();
            } else {
              setSave(true);
            }
          }}
          btnColor="red"
        />
      )}

      {(isLoading || commentLoading || pwLoading) && <Loader />}
    </>
  );
}
